import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { observer } from "mobx-react-lite"
import { rootStore } from "stores/root-store"
import Home from "./home"

const Index = observer(() => {
  const navigate = useNavigate()

  useEffect(() => {
    if (!rootStore.isUserAuthorized) {
      navigate("/not-authorized")
    }
  }, [navigate])

  if (!rootStore.isUserAuthorized) return null

  return <Home />
})

export default Index
